import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { BookingProvider } from "@/context/BookingContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Checkout from "@/pages/Checkout";
import Pay from "@/pages/Pay";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

function App() {
  return (
    <LanguageProvider>
      <BookingProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/checkout/:packageId" element={<Checkout />} />
              <Route path="/pagar/:orderId" element={<Pay />} />
              <Route path="/compra-exitosa" element={<CheckoutSuccess />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BookingProvider>
    </LanguageProvider>
  );
}

export default App;
